import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * JOL Confidence — FTUE demo (3 essais).
 *
 * E1 : 1 paire mot-mot, slider JOL, distracteur 5s, test
 * E2 : 2 paires, le joueur applique seul
 * E3 : signal "prêt"
 */
import { useState } from 'react';
const DEMO_STEPS = [
    {
        idx: 1,
        title: 'Essai 1 — 1 paire',
        hint: 'Étudie, prédis ta confiance, puis rappelle.',
        pairs: [{ cue: 'voiture', target: 'route' }],
    },
    {
        idx: 2,
        title: 'Essai 2 — 2 paires',
        hint: 'Même règle. La calibration compte plus que la performance.',
        pairs: [
            { cue: 'soleil', target: 'chaleur' },
            { cue: 'porte', target: 'clé' },
        ],
    },
    {
        idx: 3,
        title: 'Essai 3 — prêt',
        hint: 'Le bloc normal compte 6 à 16 paires selon ton niveau.',
        pairs: [],
    },
];
export function Demo({ onComplete, onSkip }) {
    const [stepIdx, setStepIdx] = useState(0);
    const step = DEMO_STEPS[stepIdx];
    const isLast = stepIdx === DEMO_STEPS.length - 1;
    const handleNext = () => {
        if (isLast) {
            onComplete();
            return;
        }
        setStepIdx((i) => i + 1);
    };
    return (_jsxs("div", { className: "flex flex-1 flex-col items-center gap-s4 py-s4 text-center", children: [_jsx("p", { className: "font-mono text-[9.5px] uppercase tracking-[0.30em] text-cyan-text-faint", children: "D\u00E9mo guid\u00E9e" }), _jsx("h2", { className: "font-display text-[22px] font-medium leading-7 tracking-cy-display text-cyan-text", children: step.title }), _jsx("p", { className: "max-w-[320px] text-[13.5px] text-cyan-text-secondary", children: step.hint }), step.pairs.length > 0 && (_jsx("div", { className: "flex w-full max-w-[320px] flex-col gap-s2 border border-cyan-border-faint bg-cyan-surface p-s4", children: step.pairs.map((p) => (_jsxs("div", { className: "flex items-center justify-center gap-s3", children: [_jsx("span", { className: "font-display text-[18px] text-cyan-text", children: p.cue }), _jsx("span", { className: "text-cyan-text-secondary", children: "\u2194" }), _jsx("span", { className: "font-display text-[18px] text-cyan-text", children: p.target })] }, `${p.cue}-${p.target}`))) })), _jsxs("div", { className: "mt-auto flex flex-col items-stretch gap-s3 self-stretch", children: [_jsx("button", { type: "button", onClick: handleNext, className: "inline-flex h-12 w-full items-center justify-center bg-cyan-core font-display text-[14px] font-medium tracking-[-0.01em] text-cyan-surface transition active:scale-[0.985] hover:bg-cyan-network", children: isLast ? 'Démarrer la session' : 'Essai suivant' }), _jsx("button", { type: "button", onClick: onSkip, className: "text-[12px] text-cyan-text-secondary underline-offset-4 hover:underline", children: "Passer la d\u00E9mo" })] })] }));
}
//# sourceMappingURL=demo.js.map